import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import styles from "./AscPointsHistoryItem.module.scss";
import { AscPointsHistoryItemPropsI } from "./AscPointsHistoryItem.type";
import { CalendarEmptyIcon } from "../AscIcons";
import AscTag from "../AscTag/AscTag";

dayjs.extend(relativeTime);

function AscPointsHistoryItem({
  title,
  date,
  amount,
}: AscPointsHistoryItemPropsI) {
  const pointsSuffix = amount > 1 ? " points" : " point";

  return (
    <div className={styles.element}>
      <div className={styles.leftColumn}>
        <div className={styles.dateContent}>
          <CalendarEmptyIcon className={styles.calendarIcon} />
          <div className={styles.date}>
            {dayjs(date).format("D MMMM YYYY, HH:mm")}
          </div>
        </div>
        <div className={styles.title}>{title}</div>
      </div>

      <div className={styles.rightColumn}>
        <AscTag
          className={styles.tag}
          type={"points"}
          label={(amount % 1 === 0 ? amount : amount.toFixed(2)) + pointsSuffix}
        />
      </div>
    </div>
  );
}

export default AscPointsHistoryItem;
